import EventEmitter from 'eventemitter3'
import { InjectionKey } from 'vue'
import { AppEvents } from '../eventBus'

export const EventBusInjectionKey = Symbol() as InjectionKey<EventEmitter<AppEvents>>

export const ViaCepInjectionKey = Symbol() as InjectionKey<any>

export const AccordionEventBusInjectionKey = Symbol() as InjectionKey<EventEmitter<'child:open' | 'parent:close'>>

export const DropdownRootInjectionKey = Symbol() as InjectionKey<string>
export const DropdownPreviousZIndexInjectionKey = Symbol() as InjectionKey<number>
